export type NavigationType =
  'ai-registry' | 'project' | 'organization' | 'admin' | 'settings' | 'policies';

// A pattern ending in '-' matches names starting with it, any other pattern the exact name.
export function matchesRoute(name: string, patterns: string[]): boolean {
  return patterns.some((pattern) =>
    pattern.endsWith('-') ? name.startsWith(pattern) : name === pattern,
  );
}
